import script from "./ModalDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDialog.vue?vue&type=script&setup=true&lang=js"

import "./ModalDialog.vue?vue&type=style&index=0&id=0b3ed5f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b3ed5f7"]])

export default __exports__